import { connect } from 'react-redux';
import { getMenuData } from 'shared/store/app/selectors';
import MoreItem from './MoreItem';

const mapStateToProps = (state: any) => ({
  menuData: getMenuData(state),
});

export default connect(mapStateToProps)(MoreItem);
